import { Lines, Overline } from "./Reveal";

export const Mission = ({ t }) => (
  <section id="mission" className="py-28 md:py-44 border-t border-ink/10" data-testid="mission-section">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
      <Overline className="col-span-12 md:col-span-2 mb-10 md:mb-0">{t.mission.overline}</Overline>
      <div className="col-span-12 md:col-span-9 md:col-start-4">
        <Lines lines={t.mission.lines} className="font-serif text-3xl md:text-5xl lg:text-[3.4vw] leading-[1.18] tracking-tight text-ink" />
      </div>
    </div>
  </section>
);
